export default __webpack_public_path__ + "static/hero-3c41274bafdc9b70886e6d22d026e4df.png";